export default {
  inviteFriends: "ادعو الأصدقاء",
  recieveReward:
    "قدم رمز الدعوة أو الرابط إلى أصدقائك واحصلوا على المكافآت معًا.",
  guidAndRules: "إرشادات وقواعد الدعوة",
  inviteLink: "رابط الدعوة",
  todayRewardValue: "قيمة مكافأة اليوم",
  sumOfInvited: "إجمالي المدعوين",
  invitedList: "قائمة المدعوين",
  filters: "الفلاتر",
  for: "لـ",
  invitationCodeCopied: "تم نسخ رمز الدعوة.",
  invitationLinkCopied: "تم نسخ رابط الدعوة.",
  inviteCode: "رقم الدعوة",
  noInviteMsg: "لم يقم أحد بدعوة."
};
